module.exports = __webpack_public_path__ + "img/komorebiChunYinYue.56018687.jpg";